export const en: Record<string, string> = {
  "posting.inclusionExample": "One inclusion per line, e.g.\nInitial consultation\nUp to 3 revisions\nFinal files delivered",
  "posting.clientRequirements": "Requirements from the client",
  "posting.buildsTrust": "Builds trust. You can also add photos of previous work in the next step.",
  "posting.servicePhotosHint": "Select up to 30 photos at once. Each image is cropped before it is added to the gallery.",
  "posting.rfqPhotosHint": "Add up to 30 optional photos. Without photos, your RFQ displays the KontrataPH text logo.",
  "posting.previousPhotos": "Previous work photos",
  "posting.previousPhotosHint": "Select up to 5 photos of past projects. These appear in a separate \"Previous work\" gallery on your listing.",
  "posting.previous": "Previous",
  "posting.next": "Next",
  "posting.discard": "Discard",
  "posting.previewHint": "Preview — exactly how it appears in the marketplace",
  "posting.reviewNotice": "All posts are reviewed to keep the marketplace safe and trusted.",
  "posting.pricingTerms": "Pricing / Terms",
  "posting.startingPrice": "Starting price (PHP)",
  "posting.monthlySalary": "Monthly salary (PHP)",
  "posting.typeLabel": "Type",
  "posting.workArrangement": "Work arrangement",
  "posting.benefits": "Benefits & perks",
  "photos.suggested": "suggested",
  "photos.minimum": "At least {min} photo required",
  "photos.countLabel": "photos",
  "posting.createPost": "Create & Post",
  "posting.createProject": "Create a project",
  "posting.fillDetails": "Fill in the details",
  "posting.requiredLabel": "Required",
  "posting.optionalLabel": "optional",
  "posting.batchLabel": "Post several at once",
  "posting.previousWork": "Previous work accomplished",
  "posting.previousWorkHint": "Briefly describe similar projects or jobs you've completed — clients, scope, and results.",
  "posting.included": "What's included",
  "posting.optionalPerLine": "optional, one item per line",
  "posting.detailsStep": "Fill Details",
  "posting.itemDetailsHint": "Details (size, location, scope…)",
  "posting.itemNotesHint": "Specs / notes (optional)",
  "post.owner.actions": "Post actions",
  "post.owner.close": "Close",
  "post.owner.reopen": "Reopen",
  "post.owner.reopenError": "Could not reopen this post. Try again.",
  "post.owner.confirmTitle": "Close this post?",
  "post.owner.confirmBody": "This removes your post from discovery and stops new interest. Existing conversations, offers and agreements continue.",
  "post.owner.closedNotice": "Closed to new inquiries",
  "post.owner.existingContinue": "Existing conversations and agreements can continue.",
  "post.owner.undo": "Undo",
  "post.owner.cancel": "Cancel",
  "post.owner.closeError": "Could not close this post. Try again.",
  // account and posting flows
  "posting.menu.service": "Offer a Service",
  "posting.menu.job": "Post a Job Opening",
  "posting.menu.project": "Post a Project for Bidding",
  "posting.menu.heading": "What would you like to post?",
  "posting.menu.company": "Register a Business Profile",
  "posting.menu.company.description": "Set up your organization & get verified",
  "posting.menu.companyService": "Advertise Company Services",
  "posting.menu.companyService.description": "List your company's services",
  "posting.menu.job.description": "Find employees for your business",
  "posting.menu.project.description": "Invite contractors to bid",
  "posting.menu.rfq": "Request a Quotation",
  "posting.menu.rfq.description": "Ask for price quotations",
  "posting.menu.item": "List for Sale",
  "posting.menu.item.description": "Sell items, equipment, property or a business.",
  "posting.menu.service.description": "Advertise your personal services",
  "posting.menu.footer": "One account, multiple activities — you can post any of these anytime.",
  "posting.category": "Category",
  "posting.title": "Title",
  "posting.location": "Location",
  "posting.tapToAdd": "Tap a suggestion to add it",
  "posting.moreSuggestions": "More suggestions",
  "posting.fewerSuggestions": "Show fewer",
  "posting.addInput": "Add",
  "posting.suggestedTitles": "Suggested titles",
  "posting.jobTitle": "Job title / role",
  "posting.jobTitleHint": "Use 3–200 characters for the job title.",
  "posting.jobTextLimitHint": "Up to {limit} characters.",
  "posting.jobTitleLength": "Enter a job title between 3 and 200 characters.",
  "posting.jobLocationLength": "Shorten the job location to {limit} characters or fewer.",
  "posting.jobDescriptionLength": "Shorten the description to {limit} characters or fewer.",
  "posting.jobBenefitsLength": "Shorten benefits and perks to {limit} characters or fewer.",
  "posting.jobRolePlaceholder": "Select or type a role, e.g. Electrician",
  "posting.suggestedRoles": "Suggested roles",
  "posting.benefitsPlaceholder": "e.g.\n• Paid vacation leave\n• Health insurance coverage\n• Company-provided training",
  "posting.benefitLeave": "Paid leave",
  "posting.benefitHealth": "Health coverage",
  "posting.benefitTraining": "Training provided",
  "posting.requiredSkills": "Required skills",
  "posting.jobRole": "Role",
  "posting.useSelectedDetails": "Use selected details as a starter",
  "posting.descriptionStarterHint": "Uses your title, location, work arrangement and selected skills. Add the duties and other requirements before publishing.",
  "posting.description": "Description",
  "posting.productInformation": "Product information",
  "posting.productInformationDefaults": "Common details are shown automatically. All fields are optional.",
  "posting.productInformationAdditional": "Add optional details",
  "posting.productInformationPlaceholder": "Choose a suggested field and enter its value. Field names are fixed.",
  "posting.productInformationHint": "Use only the suggested field names, once each. Enter one field per line.",
  "posting.productDetailValue": "Enter {label}",
  "posting.dimensionsExample": "e.g. 120 × 60 × 75 cm",
  "posting.dimensionsHint": "Length × width × height. Use your item's actual size and unit.",
  "posting.removeProductDetail": "Remove {label}",
  "posting.productInformationEmpty": "Choose a suggestion above to add product information.",
  "posting.productInformation.unsupported": "This field is not available for this item type. Remove it and choose a suggested field.",
  "posting.productInformation.description": "This detail belongs in Description. Shorten Description to make room, or move this line there yourself.",
  "posting.productInformation.duplicate": "This field is already added. Remove the duplicate.",
  "posting.productInformation.valueTooLong": "Keep this value within {limit} characters. Put longer details in Description.",
  "posting.productInformationInvalid": "Fix the highlighted product information fields before continuing.",
  "posting.productInformationTooLong": "Keep product information within 2,000 characters.",
  "posting.optional": "optional",
  "posting.requirements": "Requirements",
  "posting.budget": "Budget",
  "posting.rate": "Rate",
  "posting.publish": "Publish",
};

export const tl: Record<string, string> = {
  "posting.inclusionExample": "Isang kasama sa bawat linya, halimbawa:\nPaunang konsultasyon\nHanggang 3 rebisyon\nPaghahatid ng mga pinal na file",
  "posting.clientRequirements": "Mga kailangan mula sa kliyente",
  "posting.buildsTrust": "Nakakadagdag ng tiwala. Maaari ka ring magdagdag ng mga larawan ng dating trabaho sa susunod na hakbang.",
  "posting.servicePhotosHint": "Pumili ng hanggang 30 larawan nang sabay-sabay. Ika-crop muna ang bawat larawan bago idagdag sa gallery.",
  "posting.rfqPhotosHint": "Magdagdag ng hanggang 30 opsyonal na larawan. Kung walang larawan, ipapakita ng RFQ ang KontrataPH na text logo.",
  "posting.previousPhotos": "Mga larawan ng natapos na trabaho",
  "posting.previousPhotosHint": "Pumili ng hanggang 5 larawan ng mga dating proyekto. Lalabas ang mga ito sa hiwalay na gallery ng natapos na trabaho sa iyong listing.",
  "posting.previous": "Nakaraan",
  "posting.next": "Susunod",
  "posting.discard": "Itapon ang draft",
  "posting.previewHint": "Preview — eksaktong hitsura sa marketplace",
  "posting.reviewNotice": "Sinusuri ang lahat ng post upang mapanatiling ligtas at mapagkakatiwalaan ang marketplace.",
  "posting.pricingTerms": "Presyo at mga kondisyon",
  "posting.startingPrice": "Panimulang presyo (PHP)",
  "posting.monthlySalary": "Buwanang sahod (PHP)",
  "posting.typeLabel": "Uri",
  "posting.workArrangement": "Paraan ng pagtatrabaho",
  "posting.benefits": "Mga benepisyo at dagdag na pakinabang",
  "photos.suggested": "Inirerekomenda",
  "photos.minimum": "Kailangan ng hindi bababa sa {min} larawan",
  "photos.countLabel": "larawan",
  "posting.createPost": "Gumawa at mag-post",
  "posting.createProject": "Gumawa ng proyekto",
  "posting.fillDetails": "Punan ang mga detalye",
  "posting.requiredLabel": "Kinakailangan",
  "posting.optionalLabel": "opsyonal",
  "posting.batchLabel": "Sabay-sabay i-post",
  "posting.previousWork": "Mga natapos na trabaho",
  "posting.previousWorkHint": "Maikling ilarawan ang mga katulad na proyekto o trabahong natapos mo — mga kliyente, saklaw, at resulta.",
  "posting.included": "Mga kasama",
  "posting.optionalPerLine": "opsyonal, isang item bawat linya",
  "posting.detailsStep": "Punan ang mga detalye",
  "posting.itemDetailsHint": "Detalye (sukat, lokasyon, saklaw…)",
  "posting.itemNotesHint": "Mga espesipikasyon / tala (opsyonal)",
  "post.owner.actions": "Mga aksyon sa post",
  "post.owner.close": "Isara",
  "post.owner.reopen": "Muling buksan",
  "post.owner.reopenError": "Hindi muling mabuksan ang post. Subukan muli.",
  "post.owner.confirmTitle": "Isara ang post na ito?",
  "post.owner.confirmBody": "Mawawala ang post sa paghahanap at hihinto ang mga bagong interes. Magpapatuloy ang mga kasalukuyang usapan, alok at kasunduan.",
  "post.owner.closedNotice": "Sarado sa mga bagong pagtatanong",
  "post.owner.existingContinue": "Maaaring magpatuloy ang mga kasalukuyang usapan at kasunduan.",
  "post.owner.undo": "I-undo",
  "post.owner.cancel": "Kanselahin",
  "post.owner.closeError": "Hindi maisara ang post na ito. Subukan muli.",
  "posting.menu.service": "Maglista ng Serbisyo",
  "posting.menu.job": "Mag-post ng Trabaho",
  "posting.menu.project": "Mag-post ng Proyekto",
  "posting.menu.heading": "Ano ang gusto mong i-post?",
  "posting.menu.company": "Magrehistro ng Profile ng Negosyo",
  "posting.menu.company.description": "I-set up ang organisasyon mo at magpa-beripika",
  "posting.menu.companyService": "I-advertise ang mga Serbisyo ng Kompanya",
  "posting.menu.companyService.description": "Ilista ang mga serbisyo ng kompanya mo",
  "posting.menu.job.description": "Maghanap ng mga empleyado para sa negosyo mo",
  "posting.menu.project.description": "Mag-imbita ng mga contractor na mag-bid",
  "posting.menu.rfq": "Humingi ng Sipi ng Presyo",
  "posting.menu.rfq.description": "Humingi ng mga sipi ng presyo",
  "posting.menu.item": "Maglista para Ibenta",
  "posting.menu.item.description": "Magbenta ng mga item, kagamitan, ari-arian o negosyo.",
  "posting.menu.service.description": "I-promote ang iyong mga personal na serbisyo",
  "posting.menu.footer": "Isang account para sa maraming aktibidad — maaari kang mag-post anumang oras.",
  "posting.category": "Kategorya",
  "posting.title": "Pamagat",
  "posting.location": "Lokasyon",
  "posting.tapToAdd": "Pindutin ang mungkahi para idagdag",
  "posting.moreSuggestions": "Iba pang mungkahi",
  "posting.fewerSuggestions": "Ipakita ang mas kaunti",
  "posting.addInput": "Idagdag",
  "posting.suggestedTitles": "Mga mungkahing pamagat",
  "posting.jobTitle": "Pamagat / posisyon sa trabaho",
  "posting.jobTitleHint": "Gumamit ng 3–200 character para sa pamagat ng trabaho.",
  "posting.jobTextLimitHint": "Hanggang {limit} character.",
  "posting.jobTitleLength": "Maglagay ng pamagat na may 3 hanggang 200 character.",
  "posting.jobLocationLength": "Paikliin ang lokasyon sa {limit} character o mas kaunti.",
  "posting.jobDescriptionLength": "Paikliin ang paglalarawan sa {limit} character o mas kaunti.",
  "posting.jobBenefitsLength": "Paikliin ang mga benepisyo sa {limit} character o mas kaunti.",
  "posting.jobRolePlaceholder": "Pumili o mag-type ng posisyon, hal. Electrician",
  "posting.suggestedRoles": "Mga mungkahing posisyon",
  "posting.benefitsPlaceholder": "Hal.\n• Bayad na bakasyon\n• Saklaw ng health insurance\n• Pagsasanay na sagot ng kumpanya",
  "posting.benefitLeave": "Bayad na leave",
  "posting.benefitHealth": "Saklaw sa kalusugan",
  "posting.benefitTraining": "May pagsasanay",
  "posting.requiredSkills": "Mga kinakailangang kasanayan",
  "posting.jobRole": "Posisyon",
  "posting.useSelectedDetails": "Gamitin ang napiling detalye bilang panimula",
  "posting.descriptionStarterHint": "Ginagamit ang pamagat, lokasyon, paraan ng trabaho at mga napiling kasanayan mo. Idagdag ang mga tungkulin at iba pang kinakailangan bago mag-post.",
  "posting.description": "Paglalarawan",
  "posting.productInformation": "Impormasyon ng produkto",
  "posting.productInformationDefaults": "Awtomatikong ipinapakita ang karaniwang detalye. Opsyonal ang lahat ng field.",
  "posting.productInformationAdditional": "Magdagdag ng opsyonal na detalye",
  "posting.productInformationPlaceholder": "Pumili ng iminungkahing field at ilagay ang halaga nito. Hindi mababago ang pangalan ng field.",
  "posting.productInformationHint": "Gamitin lamang ang mga iminungkahing pangalan ng field, isang beses bawat isa. Isang field bawat linya.",
  "posting.productDetailValue": "Ilagay ang {label}",
  "posting.dimensionsExample": "hal. 120 × 60 × 75 cm",
  "posting.dimensionsHint": "Haba × lapad × taas. Gamitin ang aktuwal na sukat at unit ng iyong item.",
  "posting.removeProductDetail": "Alisin ang {label}",
  "posting.productInformationEmpty": "Pumili ng mungkahi sa itaas upang magdagdag ng impormasyon ng produkto.",
  "posting.productInformation.unsupported": "Hindi available ang field na ito para sa uri ng item. Alisin ito at pumili ng iminungkahing field.",
  "posting.productInformation.description": "Sa Description ilagay ang detalyeng ito. Paikliin ang Description para magkasya, o ikaw mismo ang maglipat ng linyang ito roon.",
  "posting.productInformation.duplicate": "Naidagdag na ang field na ito. Alisin ang duplicate.",
  "posting.productInformation.valueTooLong": "Panatilihin ang halagang ito sa loob ng {limit} character. Ilagay ang mas mahabang detalye sa Description.",
  "posting.productInformationInvalid": "Ayusin ang naka-highlight na field ng impormasyon ng produkto bago magpatuloy.",
  "posting.productInformationTooLong": "Panatilihin ang impormasyon ng produkto sa loob ng 2,000 character.",
  "posting.optional": "opsyonal",
  "posting.requirements": "Mga Kinakailangan",
  "posting.budget": "Badyet",
  "posting.rate": "Singil",
  "posting.publish": "I-publish",
};
